import React from 'react';
import '../styles/citizen-sprite.css';

export type WebsiteCitizenSize = 'sm' | 'md' | 'lg';

export interface WebsiteCitizenSpriteProps {
  alt: string;
  size?: WebsiteCitizenSize;
  /** Turntable lento nas 8 direções. Com reduced-motion fica a vista frontal. */
  spin?: boolean;
  className?: string;
}

/**
 * Cidadão do concept idle (mesma folha do hero).
 * `alt` vazio = decorativo (`aria-hidden`).
 */
export const WebsiteCitizenSprite: React.FC<WebsiteCitizenSpriteProps> = ({
  alt,
  size = 'md',
  spin = false,
  className = '',
}) => {
  const decorative = alt.trim() === '';
  const spinClass = spin ? ' lp-citizen--spin' : '';

  return (
    <span
      className={`lp-citizen lp-citizen--${size}${spinClass} ${className}`.trim()}
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : alt}
      aria-hidden={decorative || undefined}
    />
  );
};
